import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    flex-direction: column;
`
export const OverContainer = styled(Box)`
    width: 96%;
    justify-content: center;
    align-items: start;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
        flex-direction: row;
        justify-content: space-between;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: row;
        justify-content: space-between;
    }
`
export const SectionTypography = styled(Box)`
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 49%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 49%;
    }
`
export const SectionForm = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
    }
`
export const TitleSection = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 129.5%;
    text-align: start;
    color: transparent;
    background: ${({ theme }) => theme.colors.lineaGradiant};
    -webkit-background-clip: text;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 26px;
        line-height: 129.5%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        font-size: 46px;
        line-height: 129.5%;
    }
`
export const InformationSection = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    font-weight: 400;
    text-align: start;
    padding-top: 22px;
    font-size: 13.5px;
    line-height: 150%;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 12px;
        line-height: 150%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        font-size: 16px;
        line-height: 150%;
    }
`
